export default "__VITE_ASSET__YOmCUrVi__"